import type { DlsgPolicy, DlsgPolicyConfig } from '@repo/api-gw-sdk';
import {
  ResourceType,
  ScheduleMode,
  StandardBackupScheduleFrequency,
} from '@repo/api-gw-sdk';

export const defaultDlsgPolicyConfig: DlsgPolicyConfig = {
  pathPrefixes: ['/'],
  isTruncateData: false,
  migrationDelayHours: 5 * 24,
};

export const defaultDlsgPolicy: DlsgPolicy = {
  id: '',
  name: '',
  resourceInclusion: [],
  scheduleMode: ScheduleMode.SCHEDULE_MODE_BASIC,
  policyPlan: {
    resourceTypes: [ResourceType.AwsS3],
    backupSchedules: [
      {
        vaultId: '',
        backupRetentionDays: 5,
        scheduleConfig: {
          frequency:
            StandardBackupScheduleFrequency.STANDARD_BACKUP_SCHEDULE_DAILY,
          dailyConfig: {
            timeOfDay: {
              hour: 0,
              minute: 0,
            },
          },
        },
      },
    ],
    dlsgConfig: [defaultDlsgPolicyConfig],
  },
};
